'use strict'

import Filters from './Filters'
import Archives from  '../wp_components/Archives'
import Processess from '../pages/Processess'
import Hammer from '../../components/hammer.min'
import Extras from '../tools/Extras'
import Products from '../pages/Products'

export default class Sidebar
{
  constructor()
  {
    this.$elem = $('.Sidebar')

    if( this.$elem.length > 0 ) {
      let self = this

      $( document ).ready(function() {
        Sidebar.resizeSidebar()

        /*self.$elem.hover(
            function(){
                // Mouse enter
                if( window.innerWidth >= 1024 ){
                  if( !$(this).hasClass('-hover') && !$(this).hasClass('show_complete') ){
                    $(this).addClass('-hover', 300, 'swing')
                  }
                }
            },
            function(){
                // Mouse leave
                if( window.innerWidth >= 1024 ){
                  if( $(this).hasClass('-hover') && !$(this).hasClass('show_complete') ){
                      $(this).removeClass('-hover', 300, 'swing')
                  }
                }
            }
        )*/

        self.$elem.on('click', function( event ){
          if( event.target.classList[0] == 'Sidebar' || 
              event.target.classList[0] == 'Sidebar__indicator' ||
              event.target.parentElement.classList[0] == 'Sidebar__indicator' || 
              event.target.parentElement.parentElement.classList[0] == 'Sidebar__indicator'
          ) {
            if( window.innerWidth >= 1024 && !$(this).hasClass('show_complete') ){
              if( !$(this).hasClass('-hover') ){
                $(this).addClass('-hover', 300, 'swing')
              } else{
                $(this).removeClass('-hover', 300, 'swing')
              }
            }
          }
        })

        self._launchEvents( self.$elem )

        self.offsetTopToSticky = 0
        if ( $('.Page.Processess').length > 0 ) {
          self.offsetTopToSticky = self.$elem.find('.item_sidebar.controls_processes').offset().top
        } else if ( $('.Single.Sustainability').length > 0 ) {
          self.offsetTopToSticky = self.$elem.find('.item_sidebar.controls_sustainability').offset().top
        } else if ( $('.Single.Products').length > 0 ) {
          self.offsetTopToSticky = self.$elem.find('.item_sidebar.controls_products').offset().top
        } else{
          self.offsetTopToSticky = self.$elem.offset().top
        }

        if( window.innerWidth < 1024 ){
          let $copy = self.$elem.clone()
          $copy.insertBefore($('#wrapper'))
          self._launchEvents( $copy )
        }
      })

      $(window).resize( ()=> {
        Sidebar.resizeSidebar()
      })

      $(window).on("orientationchange", ()=> {
        Sidebar.resizeSidebar()
      })

      $( window ).scroll( ()=> {
          if( window.innerWidth >= 1024 ) {
            let $elem = $('.Sidebar')
            let $headerPage = $('#header')
            let currentScroll = $(window).scrollTop() + $headerPage.outerHeight()

            if ( currentScroll >= self.offsetTopToSticky ) {
              if (!$elem.hasClass('sticky')) {
                $elem.addClass('sticky')
              }

              let valueHeight = $(document).outerHeight() - $('.Footer').outerHeight()
              valueHeight -= currentScroll

              $elem.css({
                'height' : valueHeight
              })
            } else {
              if ($elem.hasClass('sticky')) {
                $elem.removeClass('sticky')
                if( $elem.attr('style') != undefined ){
                  $elem.removeAttr('style')
                }
              }
            }

            if( $('#wrapper').siblings('.Sidebar').length > 0 ){
              $('#wrapper').siblings('.Sidebar').remove()
            }
          } else{
            if( $('#wrapper').siblings('.Sidebar').length == 0 ){
              let $copy = self.$elem.clone()
              $copy.insertBefore($('#wrapper'))
              self._launchEvents( $copy )
            }
          }
      })
    }
  }

  static resizeSidebar()
  {
    let $header_category = $('.HeaderPage__category')
    let $sidebar = $('.Sidebar')
    let $sidebar_container = $sidebar.find('.Sidebar__container')

    if( window.innerWidth >= 1024 ){
      $sidebar_container.css({
        //'max-height' : $sidebar.outerHeight()
      })

      if( window.innerWidth >= 1250 ){
        let value_to_show_complete = window.innerWidth - 1200
        
        if( value_to_show_complete / 2 >= 320 ){
          if( !$sidebar.hasClass('show_complete') ){
            $sidebar.addClass('show_complete', 300, 'swing')
          }
        } else{
          if( $sidebar.hasClass('show_complete') ){
            $sidebar.removeClass('show_complete', 300, 'swing')
          }
        }
      }
    } else{
      if( $sidebar.attr('style') != undefined ){
        $sidebar.removeAttr('style')
      }
    }
  }

  _launchEvents( $elem )
  {
    let self = this
    let elem = $elem

    let $button_close = elem.find('.Sidebar__close')
    $button_close.on('click', function( event ) {
      event.preventDefault()
      event.stopImmediatePropagation()
      if( $(this).parent().hasClass('-hover') ){
        $(this).parent().removeClass('-hover', 300, 'swing')

        if( $('html').hasClass('safari7') || $('html').hasClass('safari8') || $('html').hasClass('safari9') ){
          $(this).parent().removeClass('showed', 300, 'swing')
        }
      }
    })

    let $filter_news = elem.find('.filter_news')
    $filter_news.children().on('click', function( event ){
      event.preventDefault()
      event.stopPropagation()

      self._filterNews( $(this) )
    })

    let $buttonsProcessess = elem.find( ".controls_processes .item" ),
        categoryLaunch = $('#taxonomy').val()
    
    elem.find('.controls_processes .item[category="'+ categoryLaunch +'"]').addClass('active')
    $buttonsProcessess.on('click', function( event ){
      event.preventDefault()
      event.stopImmediatePropagation()

      $(this).addClass('active').siblings().removeClass('active')

      self._actionsProcessess($(this), self)
    })

    let $buttonsSustainability = elem.find( ".controls_sustainability .item" ),
        currentCategory = $('.Sustainability__container').attr('category')
    
    elem.find('.controls_sustainability .item[category="'+ currentCategory +'"]').addClass('active')
    $buttonsSustainability.on('click', function( event ){
      event.preventDefault()
      event.stopImmediatePropagation()

      $(this).addClass('active').siblings().removeClass('active')

      self._getDataSustainability($(this), self)
    })

    let $buttonsProducts = elem.find( ".controls_products .item" ),
        currentProduct = $('.Products__container').attr('data-product')
        
    elem.find('.controls_products .item[data-product="'+ currentProduct +'"]').addClass('active')
    $buttonsProducts.on('click', function( event ){
      event.preventDefault()
      event.stopImmediatePropagation()

      $(this).addClass('active').siblings().removeClass('active')

      self._getDataProducts($(this), self)
    })
  }

  _filterNews( $elem )
  {
    let newVale = $elem.attr('data-type')
    Filters._changeSearchs( newVale )

    let $loader = $('.loader_theme'),
        $currentPage = $('.Archive__results').children('.active')

    $currentPage.fadeOut('slow', function(){
      $currentPage.removeClass('active')
      $currentPage.removeAttr('style')
      $loader.addClass('active').hide()

      $loader.fadeIn('slow', function(){
        //Sidebar.resizeContainer()

        setTimeout(function(){
          $elem.addClass('inactive').siblings().removeClass('inactive')

          let $categoryHeader = $('.HeaderPage__category figure')

          $categoryHeader.children('figcaption').text( $elem.text() )
          $categoryHeader.children('img').attr('src', $elem.children('img').attr('src'))

          $loader.fadeOut('slow', function(){
              $loader.removeClass('active')
              //Sidebar.resizeContainer()

              $currentPage.siblings('[data-type="'+ newVale +'"]').fadeIn('slow', function(){
                  $currentPage.siblings('[data-type="'+ newVale +'"]').addClass('active')
                  $currentPage.siblings('[data-type="'+ newVale +'"]').removeAttr('style')
                  Archives._adjustSizesItems()
                  //Sidebar.resizeContainer()
              })
            })
        }, 2000)
      })
    })
  }

  _actionsProcessess($this, _self)
  {
    let taxonomy = $this.attr('category'),
        $container = $('.Processess__container'),
        $loader = $('.loader_theme'),
        $buttonMore = $('.Processess__buttonMore')

    $('#taxonomy').val(taxonomy)
    $container.attr('data-process',taxonomy)
    $('#paged').val(1)
    $('.quantity').remove()

    $container.children('.item').remove()
    $loader.addClass('show')
    $buttonMore.addClass('disabled')

    $buttonMore.hide()

    for( let i = 0; i < window.objsAnimations.length; i++){
      window.objsAnimations[i].kill()
    }

    setTimeout(function(){
      Sidebar.resizeSidebar()
    }, 300)

    $.ajax({
      method: "POST",
      url: ajaxurl,
      data: { action: "obtener_infografias", paged: 0,taxonomy : taxonomy,type : 'sidebar' },
      success: function(response, status, XHR){
        $(response).insertBefore($loader)

        let $newItems = $container.children('.item'),
            objsLoaded = [],
            itemsInitialized = 0

        $newItems.hide()

        function validMoreItems(){
          var quantity = $('#quantity').val()
          var paged = $('#paged').val()
          
          if(quantity > (parseInt(paged)+1)){
            $buttonMore.fadeIn('slow', function(){
                $buttonMore.removeClass('disabled')
            })

            $loader.fadeOut('slow', function(){
                $loader.removeClass('show').removeAttr('style')
            })
          } else{
            $loader.fadeOut('slow', function(){
                $loader.removeClass('show').removeAttr('style')
            })
          }
        }

        var countItems = $newItems.length

        $.each($newItems, function (i, val) {
          let selfItem = $(this),
              idItem = selfItem.find('.item__container__actors').attr('id'),
              load = true,
              selfSidebar = Sidebar

          for(let index_for = 0; index_for < window.objsAnimations.length; index_for++) {
            let objToAnimate = window.objsAnimations[index_for]

            if (objToAnimate.vars.onUpdateParams[2].id == idItem) {
              load = false
              objsLoaded.push(objToAnimate)
            }
          }

          if (load) {
            Processess._loadResources(selfItem, function (objAnimation) {
              selfItem.fadeIn('slow', function () {
                itemsInitialized++
                objAnimation.play()
                self//Sidebar.resizeContainer()

                if (itemsInitialized == 2 || countItems == 1 ) {
                    validMoreItems()
                }
              })
            })
          }
          else {
            selfItem.fadeIn('slow', function () {
              itemsInitialized++
              objsLoaded[i].play()
              self//Sidebar.resizeContainer()

              if (itemsInitialized == 2 || countItems == 1) {
                validMoreItems()
              }
            })
          }

          if( _self.$elem.attr('style') != 'undefined' ){
            _self.$elem.removeAttr('style')
          }
        })
      }
    })
  }

  _getDataSustainability($this, _self)
  {
    let $container = $('.Sustainability .Sustainability__container'),
        $loader = $('.loader_theme'),
        id = $this.attr('post'),
        category = $this.attr('category')

    if( $container.hasClass('changing') ) { return false }
    
    $loader.addClass('show')
    
    $container
      .addClass('changing')
      .attr('category', category)
    
    $('.Sidebar .controls_sustainability .item[category="'+ category +'"]')
      .addClass('active')
      .siblings().removeClass('active')
    
    //location.valueOf().search = `?state=${category}`

    let $body = $("html, body")
    $body.stop().animate({scrollTop:$('.Single__container').offset().top}, '500', 'swing', function() {
      $container.animate({
          'height' : 200
      }, 200, 'swing', function(){
          $container.html('')
          Sidebar.resizeSidebar()
      })

      $.ajax({
        method: "POST",
        url : ajaxurl,
        data: { action: "get_sustainability_data", id: id},
        success: function(response, status, XHR){
          $container
            .removeAttr('style')
            .html(response)
            .removeClass('changing')
            .children().hide()
          
          $loader.removeClass('show')

          if( $container.find('#map').length > 0 ){
            Extras.mapFuncionality();
          }

          setTimeout(function(){
            $container.children().fadeIn(function(){
              
            })
          }, 300)

          if( _self.$elem.attr('style') != undefined ){
            _self.$elem.removeAttr('style')
          }
        }
      })
    })
  }

  _getDataProducts($this, _self)
  {
    let productID = $this.attr('data-product'),
        $loader = $('.loader_theme'),
        $container = $('.Products .Products__container'),
        $content = $container.find('.Products__container__content')

    if( $container.hasClass('changing') ) { return false }

    $container.addClass('changing')
    $loader.addClass('show', 300, 'swing')
    
    $content.hide('drop', 400, function(){
      $content.remove()
      Sidebar.resizeSidebar()
    })
    
    _self.$elem.find('.controls_products .item[data-product="'+ productID +'"]')
      .addClass('active', 300, 'swing')
      .siblings().removeClass('active', 300, 'swing')

    $.ajax({
      method: "POST",
      url : ajaxurl,
      data: { action: "get_products_data", id: productID},
      success: function(response, status, XHR){
        $container
          .append(response)
          .removeClass('changing')
          .find('.Products__container__content').hide()

        new Products()
        
        let $content = $container.find('.Products__container__content')
        $loader.removeClass('show', 300, 'swing', function(){
          $content.show('drop', 300)
          Sidebar.resizeSidebar()
        })
      }
    })
  }
}

